import { QueryFeature } from '../../../../config/queryClient';

enum QueryKey {
  AutomatedAccounts = 'AutomatedAccountsWorkflow',
}

export const queryKeys = {
  automatedAccounts: (clientId: string) => [
    QueryFeature.AutomatedAccount,
    QueryKey.AutomatedAccounts,
    clientId,
  ],
};
